import { render, staticRenderFns } from "./certificates-table-view-dialog.vue?vue&type=template&id=55f791a5&scoped=true"
import script from "./certificates-table-view-dialog-script?vue&type=script&lang=js&external"
export * from "./certificates-table-view-dialog-script?vue&type=script&lang=js&external"
import style0 from "./certificates-table-view-dialog.vue?vue&type=style&index=0&id=55f791a5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f791a5",
  null
  
)

export default component.exports